import { ErrorHandler, inject } from "@angular/core";
import { ErrorService } from "./error.service";
import { alertaLoaderHTML } from "shared-tsi";

export class TsiErrorHandler implements ErrorHandler {

    private errorService = inject(ErrorService)

    handleError(error: any): void {

        const message = error?.message || '';

        const isChunkError =
            message.includes('ChunkLoadError') ||
            message.includes('Loading chunk') ||
            message.includes('Failed to fetch dynamically imported module');

        if (isChunkError) {
            const alreadyReloaded = sessionStorage.getItem('chunk-reload');

            if (!alreadyReloaded) {
                sessionStorage.setItem('chunk-reload', 'true');
                const message = `<div><img src="assets/images/logo-tsi-tres.png" class="img-login" ></div>
                <div style="font-size: 1.1rem; font-weight: bolder">
                El sistema fue actualizado. La página se recargará.<div> `;
                alertaLoaderHTML(message, 3000, () => window.location.reload())
                return;
            }

        }

        sessionStorage.removeItem('chunk-reload');
        this.errorService.appError = error
    }
}